export default __webpack_public_path__ + "img/fpjeiNBi.8282272e.svg";